import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconFaceExtraHappy16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconFaceExtraHappy16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M14 8A6 6 0 1 1 2 8a6 6 0 0 1 12 0m1 0A7 7 0 1 1 1 8a7 7 0 0 1 14 0m-9.275-.7a.875.875 0 1 0 0-1.75.875.875 0 0 0 0 1.75m5.425-.875a.875.875 0 1 1-1.75 0 .875.875 0 0 1 1.75 0M8 11.5c-.923 0-1.837-.534-2.465-1.5h4.93c-.628.966-1.542 1.5-2.465 1.5m0 1c1.652 0 3.083-1.168 3.783-2.874C11.91 9.32 11.67 9 11.337 9H4.663c-.332 0-.572.319-.446.626C4.917 11.332 6.348 12.5 8 12.5"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconFaceExtraHappy16);
